import Vue from "vue";
import VueRouter from "vue-router";
Vue.use(VueRouter);

const routes = [{
    path: "/",
    name: "",
    component: () =>
        import ("../views/Index.vue"),
    meta: {
        title: "基金模拟测试",
        content: {
            keywords: '',
            description: ''
        }
    },
}, {
    path: "/fund/:id",
    name: "fund",
    component: () =>
        import ("../views/Fund.vue"),
    meta: {
        title: "基金模拟测试",
        content: {
            keywords: '',
            description: ''
        }
    },
    type: -1,
}];

const router = new VueRouter({
    mode: "history",
    base: process.env.BASE_URL,
    routes
});

export default router;


// WEBPACK FOOTER //
// ./src/router/index.js